import React from "react";

import "../../scss/molecules/_list.scss";

class ListItem extends React.Component {
  render() {
    return <li className="list-item">{this.props.children}</li>;
  }
}

export default ListItem;
